import { render } from "./ContentsTextbooks.vue?vue&type=template&id=1864288d&scoped=true"
import script from "./ContentsTextbooks.vue?vue&type=script&lang=js"
export * from "./ContentsTextbooks.vue?vue&type=script&lang=js"

import "./ContentsTextbooks.vue?vue&type=style&index=0&id=1864288d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1864288d"]])

export default __exports__